export const contentData = {
  spanish:{
    title:'Crear Inscripción',
    nodata:'Sin Registro',
    error:'Sin registro',
    button:'Guardar',
    cancelButton:'Cancelar',
    image_button:'Cambiar',
    form:{
      name:{
        label:'Nombre',
        placeholder:'Nombre',
      },
      due_date:{
        label:'Fecha Requerida',
        placeholder:'Fecha Requerida',
      },
      responsible_id:{
        label:'Responsable',
        placeholder:'Responsable'
      },
      estimated_delivery_date:{
        label:'Fecha Estimada de Entrega',
        placeholder:'Fecha Estimada de Entrega'
      }
    },
  },
}
